var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuntactSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M1.00977 11.8701V18.2101C1.00977 19.2101 1.81977 20.0201 2.81977 20.0201H4.62977C5.62977 20.0201 6.43977 19.2101 6.43977 18.2101V13.6801C6.43977 12.6801 5.62977 11.8701 4.62977 11.8701H1.00977Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22.9105 11.8701H19.2905C18.2905 11.8701 17.4805 12.6801 17.4805 13.6801V18.2101C17.4805 19.2101 18.2905 20.0201 19.2905 20.0201H21.1005C22.1005 20.0201 22.9105 19.2101 22.9105 18.2101V11.8701Z",
    fill: "#91BC68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.91 11.8702H19.29C18.29 11.8702 17.48 12.6802 17.48 13.6802V18.2102C17.48 19.2102 18.29 20.0202 19.29 20.0202H21.1C22.1 20.0202 22.91 19.2102 22.91 18.2102V11.8702ZM22.91 11.8702C22.91 5.87025 18.05 1.00025 12.04 1.00025C12.01 1.00025 11.98 1.00025 11.95 1.00025C5.95 0.960247 1.05 5.79025 1 11.7902C1 11.8202 1 11.8402 1 11.8702V18.2102C1 19.2102 1.81 20.0202 2.81 20.0202H4.62C5.62 20.0202 6.43 19.2102 6.43 18.2102V13.6802C6.43 12.6802 5.62 11.8702 4.62 11.8702H1.01",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9093 18.2104V20.9304C22.9093 22.9304 21.2893 24.5504 19.2893 24.5504H12.7793",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuntactSupport);
export default __webpack_public_path__ + "static/media/cuntactSupport.b3e3443ed2fb633fc83ef841174ae651.svg";
export { ForwardRef as ReactComponent };